module.exports = __webpack_public_path__ + "static/media/matheus_akio.1ca6e8a3.jpg";